const NavLink = ({ label, href , clickFn }) => {

  return (
    <li className="cursor-pointer hover:[#e60000]" onClick={clickFn} >
      <a href={href}  className="md:hover:text-[#e60000] text-2xl md:text-xl">{label}</a>
    </li>
  );
};

export default NavLink;
